import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import styles from "./styles.module.css";

export default function PortfolioLoadingState() {
  return (
    <Placeholder>
      <div className={styles.header}>
        <Placeholder.Image />
      </div>
      <div>
        <div className={styles.rows}>
          <Placeholder.Line />
        </div>
        <div className={styles.rows}>
          <Placeholder.Line />
        </div>
        <div className={styles.rows}>
          <Placeholder.Line />
        </div>
        <div className={styles.rows}>
          <Placeholder.Line />
        </div>
        <div className={styles.rows}>
          <Placeholder.Line />
        </div>
      </div>
    </Placeholder>
  );
}
